import MSlice from "../../helper/MSlice";

const assessmentTestSlice = new MSlice({ name: "assessmentTest" });

export const assessmentTestActions = assessmentTestSlice.getActions();

export default assessmentTestSlice.getReducer();
